import { render, staticRenderFns } from "./view-info.vue?vue&type=template&id=0cfa9012&lang=pug"
import script from "./view-info.vue?vue&type=script&lang=js"
export * from "./view-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports